import { useState } from "react";
import { SectionTitle } from "../ui";
import ClientUploadsManager from "./ClientUploadsManager";
import ReviewsMediaManager from "./ReviewsMediaManager";

const TABS = [
  { id: "client", label: "Client uploads" },
  { id: "reviews", label: "Reviews media" },
];

export default function TripMediaManager() {
  const [tab, setTab] = useState("client");
  return (
    <div data-testid="trip-media-manager">
      <SectionTitle title="Trip Media" subtitle="Client-uploaded trip photos/videos (moderation) and admin review media (e.g. Nico). Stored in secure object storage, separate from client documents." />
      <div className="mb-6 flex gap-1 border-b border-sand-200">
        {TABS.map((tb) => (
          <button key={tb.id} data-testid={`trip-media-tab-${tb.id}`} onClick={() => setTab(tb.id)}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${tab === tb.id ? "border-terracotta text-terracotta" : "border-transparent text-charcoal-500 hover:text-charcoal-800"}`}>
            {tb.label}
          </button>
        ))}
      </div>
      {tab === "client" ? <ClientUploadsManager /> : <ReviewsMediaManager />}
    </div>
  );
}
